import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import {
  Box,
  Flex,
  Image,
  IconButton,
  HStack,
  useColorMode,
  useDisclosure,
  VStack,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  Spacer,
  Text,
} from '@chakra-ui/react';
import { MdLightMode, MdDarkMode } from 'react-icons/md';
import { GiHamburgerMenu } from 'react-icons/gi';
import LightLogo from '../../assets/Logo.webp';
// import BlackLogo from '../../assets/Logo_Black.png';

function NavbarNew() {
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const location = useLocation();

  const navLinks = [
    { name: 'Home', to: '/' },
    { name: 'About Us', to: '/aboutus' },
    { name: 'Services', to: '/services' },
    // { name: 'Projects', to: '/projects' },
    { name: 'Contact Us', to: '/contact' },
    { name: 'Blog', to: '/blog' },
    { name: 'Appointment', to: '/appointment' },
  ];

  return (
    <Box as="header" py={6} px={10} boxShadow="sm" bg={colorMode === 'light' ? 'transparent' : 'gray.800'}>
      <Flex align="center" maxW="1400px" mx="auto">
        {/* Logo */}
        <RouterLink to="/">
          <Image src={LightLogo} alt="Logo" h={{md:"50px",base:"40px"}} display={colorMode === 'light' ? 'block' : 'none'} />
          <Image src={LightLogo} alt="Logo" h={{md:"50px",base:"40px"}} display={colorMode === 'dark' ? 'block' : 'none'} />
        </RouterLink>

        <Spacer />

        {/* Desktop Nav */}
        <HStack spacing={6} display={{ base: 'none', md: 'flex' }}>
          {navLinks.map((link) => (
            <RouterLink key={link.name} to={link.to}>
              <Text
                fontWeight={location.pathname === link.to ? "extrabold" : "medium"}
                fontSize={location.pathname === link.to ? "lg" : "md"}
                color={location.pathname === link.to ? 'blue.400' : 'inherit'}
                _hover={{
                  color: 'blue.300',
                  textDecoration: 'none',
                }}
                transition="color 0.3s"
              >
                {link.name}
              </Text>
            </RouterLink>
          ))}
        </HStack>

        <Spacer />

        {/* Controls */}
        <HStack spacing={3}>
          {/* Light/Dark Mode */}
          <IconButton
            // icon={colorMode === 'light' ? <MdDarkMode /> : <MdLightMode />}
            aria-label="Toggle Color Mode"
            // onClick={toggleColorMode}
            variant="ghost"
          />

          {/* Mobile Menu */}
          <IconButton
            icon={<GiHamburgerMenu />}
            aria-label="Open Menu"
            variant="ghost"
            display={{ base: 'inline-flex', md: 'none' }}
            onClick={onOpen}
            fontSize={'3xl'}
            color={colorMode === 'light' ? 'white' : 'white'}
          />
        </HStack>
      </Flex>

      {/* Mobile Drawer */}
      <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent
          bg="gray.700"
          color="white"
          borderLeftRadius={12}
          borderLeft="2px solid rgba(10, 113, 182, 0.93)"
        >
          <DrawerCloseButton />
          <DrawerBody mt={6} p={4} display="flex" flexDirection="column" justifyContent="space-between">
            <VStack spacing={5} align="start">
              {navLinks.map((link) => (
                <RouterLink key={link.name} to={link.to} onClick={onClose}>
                  <Text
                    fontWeight="medium"
                    color={location.pathname === link.to ? 'blue.400' : 'inherit'}
                    _hover={{
                      color: 'blue.300',
                      textDecoration: 'none',
                    }}
                    transition="color 0.3s"
                  >
                    {link.name}
                  </Text>
                </RouterLink>
              ))}
            </VStack>

            <Box mt={10} pt={6} borderTop="1px solid rgba(255,255,255,0.2)" textAlign="center" fontSize="sm">
              © 2025 Dremotech Solutions. All rights reserved.
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
}

export default NavbarNew;
